import gql from 'graphql-tag';

const UPDATE_BROKER = gql`
  mutation Mutation($deviceSerialNo: String!, $broker: String!) {
    updateBroker(deviceSerialNo: $deviceSerialNo, broker: $broker) {
      code
    }
  }
`;

export default UPDATE_BROKER;
